/**
 * The firm-registration SOP, as the applicant and the secretariat see it:
 *
 *   pending_payment      registration fee not paid yet
 *   awaiting_endorsement paid; waiting on two referees and the chapter
 *   under_review         all endorsements in; with the secretariat
 *   with_committee       handed to the Membership Committee
 *   returned             sent back to the applicant to correct
 *   rejected             a committee member returned it to the secretariat
 *   ready_for_interview  committee approved; interview to be held
 *   pending_donation     interview done; the agreed donation is outstanding
 *   donated              donation paid; waiting on its firm number
 *   approved             firm number issued; registered as a firm
 */
const STYLES: Record<string, string> = {
  draft: "bg-gray-100 text-gray-600",
  pending_payment: "bg-amber-100 text-amber-700",
  awaiting_endorsement: "bg-sky-100 text-sky-700",
  under_review: "bg-indigo-100 text-indigo-700",
  with_committee: "bg-violet-100 text-violet-700",
  returned: "bg-orange-100 text-orange-700",
  rejected: "bg-red-100 text-red-700",
  ready_for_interview: "bg-teal-100 text-teal-700",
  pending_donation: "bg-amber-100 text-amber-700",
  donated: "bg-emerald-100 text-emerald-700",
  approved: "bg-green-100 text-green-700",
};

const LABELS: Record<string, string> = {
  draft: "Draft",
  pending_payment: "Awaiting Payment",
  awaiting_endorsement: "Awaiting Endorsement",
  under_review: "Under Review",
  with_committee: "With Committee",
  returned: "Returned",
  rejected: "Rejected",
  ready_for_interview: "Ready for Interview",
  pending_donation: "Donation Due",
  donated: "Donated",
  approved: "Approved",
};

export const FIRM_STATUS_LABEL = (s?: string) => LABELS[s ?? ""] ?? s ?? "—";

export default function FirmStatusBadge({ status }: { status?: string }) {
  const s = status ?? "draft";
  return (
    <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-semibold ${STYLES[s] ?? "bg-gray-100 text-gray-600"}`}>
      {LABELS[s] ?? s}
    </span>
  );
}
